const protectedKeys = [
  'alternateLinks',
];

const recursiveLanguageResolve = (item, language) => {
  if (item === undefined) {
    return undefined;
  }

  const reviver = (key, value) => {
    if (
      protectedKeys.indexOf(key) === -1
      && value
      && value[language] !== undefined
    ) {
      return value[language];
    }

    return value;
  };

  return JSON.parse(JSON.stringify(item), reviver);
};

module.exports = recursiveLanguageResolve;



// WEBPACK FOOTER //
// ./src/_utilities/recursive-language-resolve.js